/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addHatchery } from '../fn/hatchery/add-hatchery';
import { AddHatchery$Params } from '../fn/hatchery/add-hatchery';
import { deleteHatchery } from '../fn/hatchery/delete-hatchery';
import { DeleteHatchery$Params } from '../fn/hatchery/delete-hatchery';
import { findAll } from '../fn/hatchery/find-all';
import { FindAll$Params } from '../fn/hatchery/find-all';
import { findByRoleName } from '../fn/hatchery/find-by-role-name';
import { FindByRoleName$Params } from '../fn/hatchery/find-by-role-name';
import { Hatchery } from '../models/hatchery';
import { setActiveHatchery } from '../fn/hatchery/set-active-hatchery';
import { SetActiveHatchery$Params } from '../fn/hatchery/set-active-hatchery';
import { updateHatchery } from '../fn/hatchery/update-hatchery';
import { UpdateHatchery$Params } from '../fn/hatchery/update-hatchery';

@Injectable({ providedIn: 'root' })
export class HatcheryService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findAll()` */
  static readonly FindAllPath = '/api/hatchery';

  /**
   * Find All.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll$Response(params?: FindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Hatchery>>> {
    return findAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Find All.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAll(params?: FindAll$Params, context?: HttpContext): Observable<Array<Hatchery>> {
    return this.findAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Hatchery>>): Array<Hatchery> => r.body)
    );
  }

  /** Path part for operation `addHatchery()` */
  static readonly AddHatcheryPath = '/api/hatchery';

  /**
   * Add Hatchery.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addHatchery()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addHatchery$Response(params: AddHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<Hatchery>> {
    return addHatchery(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Hatchery.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addHatchery$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addHatchery(params: AddHatchery$Params, context?: HttpContext): Observable<Hatchery> {
    return this.addHatchery$Response(params, context).pipe(
      map((r: StrictHttpResponse<Hatchery>): Hatchery => r.body)
    );
  }

  /** Path part for operation `deleteHatchery()` */
  static readonly DeleteHatcheryPath = '/api/hatchery/hatchery/{hatcheryId}';

  /**
   * Delete Hatchery.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteHatchery()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteHatchery$Response(params: DeleteHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<Hatchery>> {
    return deleteHatchery(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Hatchery.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteHatchery$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteHatchery(params: DeleteHatchery$Params, context?: HttpContext): Observable<Hatchery> {
    return this.deleteHatchery$Response(params, context).pipe(
      map((r: StrictHttpResponse<Hatchery>): Hatchery => r.body)
    );
  }

  /** Path part for operation `findByRoleName()` */
  static readonly FindByRoleNamePath = '/api/hatchery/{hatcheryId}';

  /**
   * Find By Role Name.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByRoleName()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByRoleName$Response(params: FindByRoleName$Params, context?: HttpContext): Observable<StrictHttpResponse<Hatchery>> {
    return findByRoleName(this.http, this.rootUrl, params, context);
  }

  /**
   * Find By Role Name.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findByRoleName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findByRoleName(params: FindByRoleName$Params, context?: HttpContext): Observable<Hatchery> {
    return this.findByRoleName$Response(params, context).pipe(
      map((r: StrictHttpResponse<Hatchery>): Hatchery => r.body)
    );
  }

  /** Path part for operation `updateHatchery()` */
  static readonly UpdateHatcheryPath = '/api/hatchery/{hatcheryId}';

  /**
   * Update Hatchery.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateHatchery()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateHatchery$Response(params: UpdateHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<Hatchery>> {
    return updateHatchery(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Hatchery.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateHatchery$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateHatchery(params: UpdateHatchery$Params, context?: HttpContext): Observable<Hatchery> {
    return this.updateHatchery$Response(params, context).pipe(
      map((r: StrictHttpResponse<Hatchery>): Hatchery => r.body)
    );
  }

  /** Path part for operation `setActiveHatchery()` */
  static readonly SetActiveHatcheryPath = '/api/hatchery/{hatcheryId}/setActive={isActive}';

  /**
   * Set Active Hatchery.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setActiveHatchery()` instead.
   *
   * This method doesn't expect any request body.
   */
  setActiveHatchery$Response(params: SetActiveHatchery$Params, context?: HttpContext): Observable<StrictHttpResponse<Hatchery>> {
    return setActiveHatchery(this.http, this.rootUrl, params, context);
  }

  /**
   * Set Active Hatchery.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setActiveHatchery$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setActiveHatchery(params: SetActiveHatchery$Params, context?: HttpContext): Observable<Hatchery> {
    return this.setActiveHatchery$Response(params, context).pipe(
      map((r: StrictHttpResponse<Hatchery>): Hatchery => r.body)
    );
  }

}
